

import { Product } from '@/types/ProductType';
import { useTranslation } from "react-i18next";
import Item from './Item';

interface ItemProps {
    items: Pick<Product, "_id"|"price"| "nameEN"| "nameAR"| "descriptionAR"| "descriptionEN"| "image">[];
}

export default function Items({ items }: ItemProps) {
  const { t } = useTranslation();

    return (
        <div className="flex flex-col gap-2">
            {items.map((item) => {
                return (
                    <Item
                    
                        price={item.price}
                        title={t(item.nameEN, item.nameAR) as string} // Translate title
                        descriptionAR={item.descriptionAR} // Translate description
                        descriptionEN={item.descriptionEN} // Translate description
                        image={item.image as string} // Pass image
                        key={item._id} // Unique key for each item
                    />
                );
            })}
        </div>
    );
}
